// extracted by mini-css-extract-plugin
export default {"AppBlog":"AppBlog_AppBlog__5oP8M","AppBlog__cards":"AppBlog_AppBlog__cards__G-D-O","AppBlog__arrows":"AppBlog_AppBlog__arrows__Ph9fs"};